/**
 * School fee payment row helpers (cancellation workflow).
 */

import { isMainSchoolAccount, mainSchoolAccountDisplayName } from './schoolAccount';

export {
  isMainSchoolAccount,
  mainSchoolAccountDisplayName,
  resolveMongoId,
  resolveSchoolAccountEmail,
} from './schoolAccount';

export function normalizePaymentStatus(payment) {
  const s = String(payment?.status ?? 'active').trim().toLowerCase();
  if (s === 'cancelled') return 'cancelled';
  if (s === 'pending_cancellation') return 'pending_cancellation';
  return 'active';
}

export function isPaymentCancelled(payment) {
  return normalizePaymentStatus(payment) === 'cancelled';
}

export function isPaymentPendingCancellation(payment) {
  return normalizePaymentStatus(payment) === 'pending_cancellation';
}

export function isPaymentCountedInTotals(payment) {
  return !isPaymentCancelled(payment);
}

export function newSchoolFeePaymentId() {
  return `fp_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function paymentStatusLabel(payment) {
  const st = normalizePaymentStatus(payment);
  if (st === 'cancelled') return 'Cancelled';
  if (st === 'pending_cancellation') return 'Pending cancellation';
  return 'Active';
}

export function sumCountedPayments(payments) {
  if (!Array.isArray(payments)) return 0;
  let total = 0;
  for (const p of payments) {
    if (!p || !isPaymentCountedInTotals(p)) continue;
    total += parseFloat(p.amountpaid) || 0;
  }
  return total;
}
